import type { DocMigration } from "../docMigration";

const OLD_PREFIX = "Absolute Vertical Datum";

const migration: DocMigration = {
  id: "20260424_rename_absolute_vertical_datum_display_name",
  description: "Rename shareable vertical datum display name from Absolute Vertical Datum to Origin Relative Datum",
  apply(json: any) {
    const datums: Record<string, any> | undefined = json.datums;
    if (!datums) {
      return json;
    }

    for (const datum of Object.values(datums)) {
      if (!datum || typeof datum.name !== "string") {
        continue;
      }

      if (datum.datumType !== "SHAREABLE") {
        continue;
      }

      if (!datum.name.startsWith(OLD_PREFIX)) {
        continue;
      }

      datum.name = "Origin Relative Datum" + datum.name.slice(OLD_PREFIX.length);
    }

    return json;
  },
};

export default migration;
